import {
  quickRepliesResponseSchema,
  quickReplyResponseSchema,
  type QuickReply,
  type SaveQuickReplyBody,
} from '@chatapp-inbox/shared';
import { request } from './http';

// Respostas rápidas (docs/quick-replies.md). A lista é de quem atende; as escritas, SÓ do administrador.

export async function listQuickReplies(signal?: AbortSignal): Promise<QuickReply[]> {
  const { quickReplies } = await request('/quick-replies', {
    schema: quickRepliesResponseSchema,
    ...(signal ? { signal } : {}),
  });
  return quickReplies;
}

export async function createQuickReply(body: SaveQuickReplyBody): Promise<QuickReply> {
  const { quickReply } = await request('/admin/quick-replies', {
    method: 'POST',
    body,
    schema: quickReplyResponseSchema,
  });
  return quickReply;
}

export async function updateQuickReply(id: string, body: SaveQuickReplyBody): Promise<QuickReply> {
  const { quickReply } = await request(`/admin/quick-replies/${encodeURIComponent(id)}`, {
    method: 'PUT',
    body,
    schema: quickReplyResponseSchema,
  });
  return quickReply;
}

export async function deleteQuickReply(id: string): Promise<void> {
  await request(`/admin/quick-replies/${encodeURIComponent(id)}`, { method: 'DELETE' });
}
